<template>
  <div class="portal-question">
    <div class="header">
      <div>
        <span class="title">常见问题</span>
        <span class="refresh" @click="handleRefresh">换一换</span>
      </div>
      <!-- <a class="more" :href="host.portalUrl + '/question'" target="_blank"
        >查看全部 ></a
      > -->
    </div>
    <div class="list">
      <ul>
        <li v-for="question of questionList" :key="question.knowledgeId">
          <span></span>
          <a
            target="_blank"
            :href="host.portalUrl + '/question/' + question.knowledgeId"
            >{{ question.knowledgeTitle }}</a
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { host } from "src/config";
import { qryKnowledge } from "./../../request/portal";

export default {
  name: "PortalQuestion",
  props: {
    env: {
      type: String,
      default: "local",
    },
  },
  data() {
    return {
      host: host(this.env),
      questionList: [],
    };
  },
  methods: {
    // 换一换
    handleRefresh() {
      this.qryList();
    },
    // 查询列表
    qryList() {
      qryKnowledge({ qryNum: 6, knowledgeType: "Q&A" }, this.host.nodeUrl).then(
        (res) => {
          if (res && res.data && res.data.items)
            this.questionList = res.data.items;
        }
      );
    },
  },
  mounted() {
    this.qryList();
  },
};
</script>

<style lang="scss">
@import "./../../assets/style/mixin.scss";

.portal-question {
  width: 400px;
  box-sizing: border-box;
  padding: 20px 25px;
  background: #fff;
  display: block;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      font-weight: 700;
      font-size: 16px;
      color: #333;
      padding-left: 13px;
      border-left: 3px solid $mainColor;
    }

    .refresh {
      margin-left: 28px;
      padding-left: 20px;
      color: $mainColor;
      font-size: 12px;
      background: url("./../../assets/images/portal/question/refresh.png")
        no-repeat left center;
      cursor: pointer;
    }

    .more {
      color: $textColor;
      font-size: 12px;
    }
  }

  .list {
    margin-top: 15px;

    ul {
      padding: 0;
      margin: 0;
    }

    li {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 5px 0;

      span {
        width: 3px;
        height: 3px;
        background: #999;
        border-radius: 50%;
      }

      a {
        color: #333;
        font-size: 14px;
        padding-left: 12px;
        word-wrap: break-word;
        white-space: normal;
        word-break: break-all;
        flex: 1;
      }
    }
  }

  a:hover {
    color: $mainColor !important;
  }
}
</style>
